import React from 'react';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import Hours from 'bento-ordering/locations/components/Hours';

function LocationCardFulfillmentHours({
  hours,
  weekdayHours,
  hoursDataTestId,
  hoursLabel
}) {
  return (
    <Box mt={1} data-testid={hoursDataTestId}>
      <Hours
        label={hoursLabel}
        aboveTheFoldHours={hours}
        belowTheFoldHours={weekdayHours}
      />
    </Box>
  );
}

LocationCardFulfillmentHours.propTypes = {
  hours: PropTypes.array.isRequired,
  weekdayHours: PropTypes.array.isRequired,
  hoursDataTestId: PropTypes.string.isRequired,
  hoursLabel: PropTypes.string.isRequired
};

export default LocationCardFulfillmentHours;
